import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  components as DefaultSelectComponents,
  MultiValueGenericProps,
} from 'react-select';
import _get from 'lodash/get';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import { getAllOption } from '@lib/enums/form';
import styles from '../Select.module.scss';

function MultiValueContainer({ children, ...props }: MultiValueGenericProps) {
  const { t } = useTranslation();
  const { data } = props;
  const { label, value, color, leftIcon } = data;
  if (children === null) return children;
  const allOption = getAllOption(t);
  if (value === allOption.value) return allOption.label;
  let leftIconValue: string | undefined;
  if (color) {
    leftIconValue = 'circle';
  }
  if (leftIcon) {
    leftIconValue = leftIcon;
  }
  return (
    // @ts-ignore
    <DefaultSelectComponents.MultiValueContainer {...props}>
      <div className={styles.multiValueContainerBox}>
        <Chip
          label={label}
          leftIcon={leftIconValue}
          rightIconComponent={_get(children, 1)}
          size={ChipSizes.medium}
          type={colorToChipType(color, ChipTypes.chipGray)}
        />
      </div>
    </DefaultSelectComponents.MultiValueContainer>
  );
}

export default MultiValueContainer;
